import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { BROWN_OVERLAY, BANNER_BIEGE_BG } from '../../theme';
import { ContentEntityLayout, EntityTitleHeader, SliceLayoutBoundary } from '@shapeable/ui';

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
  `,
});

const ContentLayoutStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(8)};
    margin-top: ${theme.UNIT(8)};
  `,
  tablet: css`
    margin-top: ${theme.UNIT(10)};
  `,
  desktop: css`
    margin-top: ${theme.UNIT(12)};
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
  ContentLayout: styled(ContentEntityLayout)`${ContentLayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { entity, slices, className } = props;

  return (
    <My.Container className={className}>
      <EntityTitleHeader backgroundImage={BANNER_BIEGE_BG} overlayColor={BROWN_OVERLAY} entity={entity} />
      <SliceLayoutBoundary verticalPadding='none'>
        <My.ContentLayout 
          showTitles
          showMeta={false}
          showImage={false}
          entity={entity} />
      </SliceLayoutBoundary>
      {slices}
    </My.Container>
  )
};
